<script setup>
const {
  data: list
} = await useFetch2('/api/articles')
</script>

<template lang="pug">
AppContainer(slim).my-4
  div(style="min-height: 200px")
    WebEmpty(
      v-if="!list.list || !list.list.length"
    ) 暂无内容
    WebArticleItem(
      v-else
      v-for="item in list.list"
      :key="item.id"
      v-bind="item"
    )
</template>
